import React from "react";
import OverviewCSS from "../../../style/helperCSS/EducationOverview.module.css";

const Overview = (props) => {
  return (
    <div className={`row`}>
      <div className={` ${OverviewCSS.overview_content}`}>
        <div className={`col-12 col-md-2 ${OverviewCSS.overview_img_div}`}>
          <img src="assets/images/overview.svg" alt="Overview Image"></img>
        </div>

        <div className={`col-12 col-md-10 ${OverviewCSS.overview_div}`}>
          {props.overviews.map((item, index) => (
            <div className="row">
              <div className={`col-12 ${OverviewCSS.overview_items}`}>
                <p>-</p>
                <p key={index}>{item}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Overview;
